<ngx-simplebar style="position: relative">
  <div class="popup-gallery d-flex mb-2">
    <div class="card1" *ngFor="let image of albums; let i = index">
      <div
        class="img-fluid mb-1 p-1 me-1 border border-1 rounded-2" [ngStyle]="setImageBg"
        [ngClass]="image.style == tab_style ? 'border-primary' : 'border-white'"
      >
        <img [src]="image.src" (click)="open(i)" width="90" />
      </div>
    </div>
  </div>
</ngx-simplebar>
<div class="w-100 d-flex align-items-center justify-content-between">
  <span class="fw-bold font-size-14">List Item Divider:</span>
  <ui-switch
  color="#34c38f"
  [checked]="divider"
  uncheckedLabel="Off"
  checkedLabel="On"
  size="small"
  class="me-2"
  (change)="toggleDivider()"
></ui-switch>
</div>
